export class KnsaixServerClient {
  constructor({
    baseUrl = "/api/v1/repository-center",
  } = {}) {
    this.baseUrl = baseUrl.replace(/\/$/, "");
  }

  async request(path, options = {}) {
    const response = await fetch(
      `${this.baseUrl}${path}`,
      {
        credentials: "include",
        ...options,
        headers: {
          Accept: "application/json",
          ...(options.body
            ? {"Content-Type": "application/json"}
            : {}),
          ...(options.headers || {}),
        },
      },
    );

    const payload = await response
      .json()
      .catch(() => ({}));

    if (!response.ok) {
      const message =
        payload?.detail ||
        payload?.message ||
        `repository_center_http_${response.status}`;

      throw new Error(message);
    }

    return payload;
  }

  async health() {
    return this.request("/health");
  }

  async scanInventory() {
    const payload = await this.request("/inventory");

    return payload.inventory ?? [];
  }

  async listInventory() {
    return this.scanInventory();
  }

  // ----------------------------------------------------------
  // P1A SECURITY BOUNDARY
  //
  // Mutations intentionally remain unavailable until P1B
  // introduces canonical IAM capabilities and governed actions.
  // ----------------------------------------------------------

  async mutate() {
    throw new Error(
      "Repository Center P1A salt-okunur modda. Yönetim işlemleri P1B IAM yetkilerinden sonra açılacak.",
    );
  }

  async install() { return this.mutate(); }
  async remove() { return this.mutate(); }
  async enable() { return this.mutate(); }
  async disable() { return this.mutate(); }
  async start() { return this.mutate(); }
  async stop() { return this.mutate(); }
  async restart() { return this.mutate(); }
  async deploy() { return this.mutate(); }
  async rollback() { return this.mutate(); }
}
